module.exports = __webpack_public_path__ + "img/banner.afde4b0a.jpg";